import { datadogLogs } from '@datadog/browser-logs';
import { ConsoleApiName } from '@datadog/browser-core';

import { version } from './version';
import { isNoiseLog } from '@/libs/helpers/logNoise';

const env = import.meta.env.VITE_DATADOG_ENV;

datadogLogs.init({
  clientToken: 'pub01e0ce3aac210adbed39aa0fdbdb58c4', // info-monitoring
  site: 'datadoghq.eu',
  forwardErrorsToLogs: true,
  forwardConsoleLogs: [ConsoleApiName.warn, ConsoleApiName.error],
  beforeSend: log => !isNoiseLog(log),
  service: 'info',
  env,
  version: `${version}-${env}`,
});

if (env === 'local') {
  datadogLogs.logger.setHandler('console');
}
